import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import ApplicationPage from "@/components/ApplicationPage";
import VitalMethodPage from "@/components/VitalMethodPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/application" element={<ApplicationPage source="Main Website" />} />
          <Route path="/vital-method" element={<VitalMethodPage />} />
          <Route path="/vital-method-application" element={<ApplicationPage source="Vital Method Page" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
